import * as React from 'react';
import { League } from '../../../../sdk/model';
import { Box, Grid, Button } from '@mui/material';
import PassingSettings from './PassingSettings';
import RushingSettings from './RushingSettings';
import ReceivingSettings from './ReceivingSettings';
import OtherSettings from './OtherSettings';
import { leagueApi } from '../../../../adapters/APIExporter'

interface scoringSettingsProps {
  league: League,
  readOnly: boolean
}

function ScoringSettings(props: scoringSettingsProps) {
  const [scoringSettings, setScoringSettings] = React.useState(props.league.currentSeason?.scoringSettings!);
  const [editing, setEditing] = React.useState(false);
  function handleChange(event, categoryName) {
    const {name, value} = event.target;
    let newScoringSettings = {...scoringSettings};
    newScoringSettings[categoryName] = {...newScoringSettings[categoryName]};
    if (newScoringSettings[categoryName].ALL) {
      newScoringSettings[categoryName].ALL = {...newScoringSettings[categoryName].ALL}
      newScoringSettings[categoryName].ALL[name] = value;
    } else {
      newScoringSettings[categoryName][name] = value;
    }
    
    setScoringSettings(newScoringSettings);
  }
  
  function save() {
    const newLeague = {...props.league};
    newLeague.currentSeason = {...newLeague.currentSeason};
    newLeague.currentSeason.scoringSettings = scoringSettings;
    leagueApi.updateLeague(newLeague.id, newLeague).then(() => setEditing(false));
  }
  
  function cancelEdit() {
    setScoringSettings(props.league.currentSeason?.scoringSettings)
    setEditing(false);
  }
  
  return <Box>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <PassingSettings scoringSettings={scoringSettings} editing={editing} handleChange={handleChange} />
      </Grid>
      <Grid item xs={6}>
        <RushingSettings scoringSettings={scoringSettings} editing={editing} handleChange={handleChange} />
      </Grid>
      <Grid item xs={6}>
        <ReceivingSettings scoringSettings={scoringSettings} editing={editing} handleChange={handleChange} />
      </Grid>
      <Grid item xs={6}>
        <OtherSettings scoringSettings={scoringSettings} editing={editing} handleChange={handleChange} />
      </Grid>
    </Grid>
    {editing ? <Box>
        <Button className="capsized-button" onClick={save}>Save</Button>
        <Button className="capsized-button" onClick={cancelEdit}>Cancel</Button>
      </Box> :
      props.readOnly || <Button className="capsized-button" onClick={() => setEditing(true)}>Edit Scoring Settings</Button>
    }
  </Box>
}

export default ScoringSettings;
